import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

function HttpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

export function translationProvider(): {
  defaultLanguage: string;
  loader: {
    provide: typeof TranslateLoader;
    useFactory: (httpClient: HttpClient) => TranslateHttpLoader;
    deps: (typeof HttpClient)[];
  };
} {
  return {
    defaultLanguage: 'en',
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient],
    },
  };
}
